import React from "react";

import "./PreviewBanner.scss";

export default function PreviewBanner() {
	const [isPreview, setIsPreview] = React.useState(localStorage.getItem('nocache'));
	const switchToProduction = () => {
		localStorage.removeItem('nocache');
		setIsPreview(false);
	}
	return isPreview && (
		<div className="preview-banner">
			<div>
				Currently in <wbr />preview&nbsp;mode
				<button onClick={switchToProduction}>Switch to Production</button>
			</div>
		</div >
	);
}